import { useRef, ReactNode } from 'react';
import { useOnScreen } from '../../hooks/useOnScreen';

interface ScrollRevealProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'left' | 'right' | 'scale';
}

export function ScrollReveal({ children, delay = 0, className = '', direction = 'up' }: ScrollRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useOnScreen(ref, 0.1);

  const transforms: Record<string, string> = {
    up: 'translateY(40px)',
    left: 'translateX(-30px)',
    right: 'translateX(30px)',
    scale: 'scale(0.9)',
  };

  return (
    <div
      ref={ref}
      className={className}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'none' : transforms[direction],
        transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
      }}
    >
      {children}
    </div>
  );
}
